import MainLogo from 'component/MainLogo';
import { IS_SERVER_LOCAL } from 'config/Env';
import LocalStorage from 'config/LocalStorage';
import {
  getCompanyDetail,
  getCompanyDetailInfo,
  getCurrentSubs, getObjectFromParams,
  getOwnerInfo,
} from 'helper/helper.js';
import { getNextPath } from 'helper/helperPermission';
import React, { PureComponent } from 'react';
import 'router/helpers';
import Routes from 'router/routes';
import DV from 'variables/DV';
import { LIST_DOMAIN } from 'variables/staticValue';
import { showErrorSnackbar, showSuccessSnackbar } from "@doopage/react-ui-kit";
import { t } from "@lingui/macro";

class Loading extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { backgroundColor } = LIST_DOMAIN[DV.partner];
    return (
      <div
        className="flex-center-col"
        style={{ height: '100vh', background: 'white', backgroundColor }}>
        <MainLogo />
      </div>
    );
  }

  redirectTo = (pathname) => {
    this.props.history.push({
      pathname,
      search: window.location.search,
      state: {
        next: {
          url: DV.url,
          params: DV.params,
        },
      },
    });
  };

  getToken = async () => {
    // LocalStorage.setToken('EkuJ3GYWC1aLxAUVQLWE6elUx1ivNw');
    let token = await LocalStorage.getToken();
    if (IS_SERVER_LOCAL && !token) token = process.env.REACT_APP_TOKEN;
    if (!token) return false;
    DV.token = token;
    DV.refreshToken = await LocalStorage.getFromLocal('refreshToken');
    DV.tokenExpireTime = await LocalStorage.getFromLocal('tokenExpireTime');
    DV.refreshTokenExpireTime = await LocalStorage.getFromLocal('refreshTokenExpireTime');
    return true;
  };

  findCompanyToLogin = () => {
    let companyToLogin;
    let { staffs = [], last_staff = {} } = DV.owner || {};
    if (last_staff && last_staff.status === 'publish') {
      companyToLogin = last_staff;
    } else {
      staffs = staffs.filter((item) => item.status === 'publish');
      if (!staffs || staffs.length === 0) {
        this.redirectTo(Routes.company.path);
        return;
      }
      // tìm cty có quyền cao nhất
      let ownerCompany = staffs.find((item) => item.is_owner);
      if (ownerCompany) companyToLogin = ownerCompany;
      else {
        staffs.sort((a, b) => b.groups.length - a.groups.length);
        companyToLogin = staffs[0];
      }
    }

    return companyToLogin;
  };

  async componentDidMount() {
    let getTokenSuccess = await this.getToken();
    if (!getTokenSuccess) {
      this.redirectTo(Routes.login.path);
      return;
    }

    let { error } = await getOwnerInfo();
    if (error) {
      this.redirectTo(Routes.login.path);
      return;
    }
    const params = getObjectFromParams(window.location.search)
    const { invite_code, redirect_action, success: successParam, error: errorParam } = params
    if (invite_code) {
      this.redirectTo(Routes.joinCompany.path);
      return;
    }

    if(redirect_action === 'add_tiktok_business') {
      if(successParam === 'true') {
        showSuccessSnackbar(t`Tích hợp tài khoản Tiktok Business thành công`);
      } else if(errorParam) {
        showErrorSnackbar(t`Tích hợp tài khoản Tiktok Business thất bại:` + ' ' + errorParam);
      }
    }

    const companyToLogin = this.findCompanyToLogin();
    // return this.redirectTo(Routes.company.path);

    if (companyToLogin) {
      let { company, groups, is_owner } = companyToLogin;
      DV.company = company;
      DV.permission = groups;
      DV.isOwner = is_owner;

      let getCompanyDetailSuccess = await getCompanyDetailInfo();
      let getCurrentSubsSuccess = await getCurrentSubs();
      if (!(getCompanyDetailSuccess && getCurrentSubsSuccess)) this.redirectTo(Routes.login.path);
      //do not use this.redirectTo function because goToHomePage() can return url with query params
      if (DV.params.promocode) this.props.history.push(getNextPath(Routes.subscriptions.path));
      else this.props.history.push(getNextPath(DV.url));
    }
  }
}

export default Loading;
